module.exports = __webpack_public_path__ + "img/bg.83143dce.jpg";